import React from "react";
import {createUseStyles} from "react-jss";
import {TriviaStatus} from "../../../state/state";
import {HintQuestionDefinition} from "../../../state/questions";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";

const useStyles = createUseStyles({
	hintContainer: {
		margin: 8,
		padding: 16,
		border: "1px solid #388BCC",
		display: "flex",
	},
	prompt: {
		marginLeft: 8,
		fontWeight: 400
	}
});

type HintPromptProps = {
	state:TriviaStatus
	question: HintQuestionDefinition
	currentHint?:number
}

export default function HintPrompt({state, question, currentHint}:HintPromptProps) {
	const classes = useStyles();

	let hints = [];
	const hintNumber = state === TriviaStatus.QuestionSummary ? question.hints.length - 1 : currentHint;
	for(let i = 0; i <= hintNumber!; i++) {
		const hint = question.hints[i];
		if(typeof hint === "string") {
			hints.push(
				<div className={classes.hintContainer} key={i} data-qa="hint">
					<DisplayText variant={TextVariant.s22reg} component="span" color="white">Hint #{i+1}:</DisplayText>
					<DisplayText className={classes.prompt} variant={TextVariant.s22reg} component="span" color="white">{hint}</DisplayText>
				</div>
			);
		} else {
			hints.push(
				<div className={classes.hintContainer} key={i} data-qa="hint">
					<DisplayText variant={TextVariant.s22reg} component="span" color="white">{hint.prompt}:</DisplayText>
					<DisplayText className={classes.prompt} variant={TextVariant.s22reg} component="span" color="white">{hint.answer}</DisplayText>
				</div>
			);
		}
	}

	return <div data-qa="question-hints">
		{hints.reverse()}
	</div>;
}